<template>
  <div class="device-content">
    <el-form label-postion="left" label-width="100px">
      <el-form-item :label="$t('device.device_name')">
        <span>{{ lamp_name }}</span>
      </el-form-item>
      <el-form-item :label="$t('device.strategy')">
        <span>{{ stg_name }}</span>
      </el-form-item>
      <el-form-item :label="$t('device.edit_trategy')">
        <el-select v-model="stg_id" :placeholder="$t('device.please_select')">
          <el-option
            v-for="item in strategyList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('device.control_mode')">
        <el-switch
          v-model="ms"
          :active-text="$t('device.control_mode')[0]"
          :inactive-text="$t('device.control_mode')[1]"
          :active-value="0"
          :inactive-value="1"
          inactive-color="gray"
        ></el-switch>
      </el-form-item>
      <template v-if="ms">
        <el-form-item :label="is_double?$t('device.lamp1_light'):$t('device.lamp_light')" class="control-slider">
          <el-slider
            v-model="light"
            :min="0"
            :max="100"
            show-input
          ></el-slider>
        </el-form-item>
        <el-form-item v-if="is_double" :label="$t('device.lamp2_light')" class="control-slider">
          <el-slider
            v-model="light2"
            :min="0"
            :max="100"
            show-input
          ></el-slider>
        </el-form-item>
        <el-form-item v-if="is_double" :label="$t('device.lamp2_light')" class="control-slider">
          <el-slider
            v-model="light2"
            :min="0"
            :max="100"
            show-input
          ></el-slider>
        </el-form-item>
      </template>
      <div class="foot-btn">
        <el-button type="primary" @click="submitControl">{{$t('control.submit')}}</el-button>
        <el-button @click="cancel">{{$t('control.cancel')}}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import lampsApi from "@/api/device/lamps";
import strategyApi from "@/api/device/strategy";
export default {
  name: "Device",
  props: {
    setData: {
      type: Object,
      default: function() {
        return {
          lamp_id: null,
          lamp_name: '',
          is_double: 0,
          light: 0,
          light2: 0,
          stg_id: null,
          stg_name: '',
          ms: 0
        }
      }
    }
  },
  data() {
    return {
      lamp_id: null,
      lamp_name: '',
      is_double: 0,
      light: 0,
      light2: 0,
      stg_id: null,
      stg_name: '',
      ms: 0,
      updateInfo: {},
      strategyList: []
    };
  },
  created() {
    this.intParams()
  },
  mounted() {
    this.getStyList();
  },
  methods: {
    intParams() {
      this.lamp_id = this.setData.lamp_id
      this.lamp_name = this.setData.lamp_name
      this.is_double = this.setData.is_double
      this.light = this.setData.light
      this.light2 = this.setData.light2
      this.stg_id = this.setData.stg_id
      this.stg_name = this.setData.stg_name
      this.ms = this.setData.ms
    },
    getStyList() {
      const that = this
      strategyApi.strategyList({ page: 1, pageSize: 200}).then((res) => {
        if (res.data.code === 1000) {
          that.strategyList = res.data.data.list
        }
      });
    },
    submitControl() {
      if(this.ms==0){
        if(!this.stg_id||this.stg_id=='0'){
          return this.$message.error(this.$t('device.please_strategy'));
        }
      }
      
      const postData = {
        light: this.light,
        light2: this.light2,
        stg_id: this.stg_id,
        ms: this.ms
      }
      const that  = this
      lampsApi.lightStrategysSave(that.lamp_id, postData).then((res) => {
          if (res.data.code === 1000) {
            if (that.ms === 1) { // 1手动
              that.lightContorl();
            }else{
              that.$message.success(this.$t('control.mod_success'));
            }
            that.$parent.closeSet();
          }else{
            that.$message.error(res.data.message)
          }
        });
    },

    lightContorl() {
      const postData = {
        model: 0,
        lamp_id: this.lamp_id,
        light: this.light,
        light2: this.light2
      }
      const that  = this
      lampsApi.lightControl(postData).then((res) => {
        if (res.data.code === 1000) {
          that.$message.success(res.data.message);
        }else{
          that.$message.error(res.data.message)
        }
      });
    },
    cancel() {
      this.$parent.closeSet();
    }
  }
};
</script>
<style lang='less'>
.control-slider{
  display: flex;
  align-items: center;
  .el-form-item__content{
    width:100%;
    flex: 1;
  }
}
.foot-btn{
  padding-left: 50px;
}

</style>